import React from 'react';
import { motion } from 'framer-motion';
import content from '../config/content.json';

function About() {
  return (
    <div className="about-page">
      <section className="page-header">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {content.about.title}
          </motion.h1>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <motion.div 
              className="about-text"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {content.about.paragraphs.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </motion.div>
            <motion.div 
              className="about-image"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img src={process.env.PUBLIC_URL + "/photos/thendral_3d.png"} alt="Thendral Mansion Building" />
            </motion.div>
          </div>

          <motion.div 
            className="why-choose"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h2>Why Choose Thendral Mansion?</h2>
            <div className="features-list">
              <div className="feature-item">
                <h3>🏆 Prime Location</h3>
                <p>Strategically located on Pollachi Road with easy access to major hubs</p>
              </div>
              <div className="feature-item">
                <h3>🔒 Safe & Secure</h3>
                <p>24/7 security ensuring peace of mind for residents</p>
              </div>
              <div className="feature-item">
                <h3>💼 Professional Management</h3>
                <p>Experienced team dedicated to your comfort</p>
              </div>
              <div className="feature-item">
                <h3>🤝 Community Living</h3>
                <p>Connect with like-minded individuals in a friendly environment</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default About;
